export const PixelEvents = {
  ViewContent: 'ViewContent',
  Contact: 'Contact',
  CompleteRegistration: 'CompleteRegistration',
  InitiateCheckout: 'InitiateCheckout',
  Purchase: 'Purchase',
  Subscribe: 'Subscribe',
  AllPurchase: 'AllPurchase',
  OneTimePurchase: 'One-timePurchase',
  SkipTrialPlanPurchase: 'Full plan sale purchase',
};

export const CelebMatchEvents = {
  CelebMatchStep: 'Celeb Match Step',
  CelebMatchReport: 'Celeb Match Report',
  CelebMatchSharePopup: 'Celeb Match Share popup',
  CelebMatchSelfie: 'Celeb Match Selfie',
  CelebMatchOnboardingShown: 'Celeb Match Onboarding shown',
  CelebMatchPick: 'Celeb Match Pick',
  CelebMatchProcessing: 'Celeb Match Processing',
  CelebMatchSearch: 'Celeb Match Search',
  CelebMatchCategory: 'Celeb Match Category',
  CelebMatchCompare: 'Celeb Match Compare',
  CelebMatchShare: 'Celeb Match Share',
  CelebMatchSkipShare: 'Celeb Match Skip Share',
  CelebMatchLimitedAppShown: 'Celeb Match Limited App Shown',
  CelebMatchSubScreenShown: 'Celeb Match Sub Screen Shown',
  CelebMatchViewReport: 'Celeb Match View Report',
};

export const CelebLookalikeEvents = {
  CelebLookalikeStep: 'Celeb Lookalike Step',
  CelebLookalikeReport: 'Celeb Lookalike Report',
  CelebLookalikeSharePopup: 'Celeb Lookalike Share popup',
  CelebLookalikeSelfie: 'Celeb Lookalike Selfie',
  CelebLookalikeOnboardingShown: 'Celeb Lookalike Onboarding shown',
  CelebLookalikeProcessing: 'Celeb Lookalike Processing',
  CelebLookalikeCompare: 'Celeb Lookalike Compare',
  CelebLookalikeShare: 'Celeb Lookalike Share',
  CelebLookalikeSkipShare: 'Celeb Lookalike Skip Share',
  CelebLookalikeLimitedAppShown: 'Celeb Lookalike Limited App Shown',
  CelebLookalikeSubScreenShown: 'Celeb Lookalike Sub Screen Shown',
  CelebLookalikeViewReport: 'Celeb Lookalike View Report',
};

export const PhotoLabEvents = {
  PhotoLabOnboardingShown: 'MyTraits Photolab Onboarding shown',
  PhotoLabOnboardingStep: 'MyTraits Photolab Onboarding Step',
  PhotoLabOnboardingQuizStep: 'MyTraits Photolab Onboarding Quiz',
  PhotoLabSkipSubScreenShown: 'MyTraits Photolab Skip Sub Screen Shown',
  PhotoLabRestoreSubScreenShown: 'MyTraits Photolab Restore Sub Screen Shown',
  PhotolabSkipPurchase: 'MyTraits Photolab Skip purchase',
  PhotolabRestorePurchase: 'MyTraits Photolab Restore purchase',
  PhotolabOnboardingPhoto: 'MyTraits Photolab Onboarding Photo',
  PhotolabOnboardingProcessing: 'MyTraits Photolab Onboarding Processing',
  PhotolabRestoreAddon: 'MyTraits Photolab Restore addon',
  PhotolabRestoreSignIn: 'MyTraits Photolab Restore sign-in',
  PhotolabSkipAddon: 'MyTraits Photolab Skip addon',
  PhotolabSkipSignIn: 'MyTraits Photolab Skip sign-in',
};
